const { VUE_APP_API_ENDPOINT, NODE_ENV = "" } = process.env;

const environment = NODE_ENV.toLowerCase();
const apiBaseUrl = VUE_APP_API_ENDPOINT;

export { environment, apiBaseUrl };
